var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',{staticClass:"pa-0",style:(`height: ${_vm.height}px; overflow: auto`)},[_c('a-table-f-api',{ref:"tableSupply",attrs:{"api":_vm.url,"model":_vm.m.list,"searchable":false,"defaults":{
        filters: _vm.filters,
        sort: { key: 'id', order: 'DESC' },
        paramName: 'tabSupply',
      }},on:{"click":function($event){return _vm.onClickReportRow($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }